module.exports = __webpack_public_path__ + "static/media/qrcode.3b2293d4.jpg";